import { Switch, Route, Redirect } from "react-router-dom";
import { useParams } from "react-router";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { LeaderboardHeader } from "@ugg/shared/components/Leaderboards/components/LeaderboardHeader";
import { LeaderboardNav } from "@ugg/shared/components/Leaderboards/components/LeaderboardNav";
import { LeaderboardRanking } from "@ugg/shared/components/Leaderboards/LeaderboardRanking";
import { ChampionLeaderboardTab } from "@ugg/shared/components/Leaderboards/ChampionLeaderboardTab";
import { REGION_OPTIONS, REGION_OPTIONS_ALL } from "@ugg/shared/components/Leaderboards/leaderboard-filters";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

export function LeaderboardsHomePage() {
  const queryParams = useQueryString();
  const { region } = queryParams || {};
  const regionFull =
    region && (REGION_OPTIONS.find((reg) => reg.value === region) || REGION_OPTIONS_ALL.find((reg) => reg.value === region));
  const { fullLabel } = regionFull || {};

  const { champion } = useParams<{ champion?: string }>();
  const { getChampionName, getChampionIdByName } = getRiotAssetsContext();
  const id = champion && getChampionIdByName(champion);
  const champName = getChampionName(id);

  const getTitleAndDesc = () => {
    if (champion) {
      if (fullLabel) {
        return {
          mainTitle: `Best ${champName} Players in ${fullLabel === "World" ? `the ${fullLabel}` : fullLabel}`,
          subTitle: `${fullLabel}'s best ${champName} players, one-tricks, pros, and more. U.GG's Champion Leaderboard for all regions in D2+.`,
        };
      } else {
        return {
          mainTitle: `Best ${champName} Players in the World`,
          subTitle: `World's best ${champName} players, one-tricks, pros, and more. U.GG's Champion Leaderboard for all regions in D2+.`,
        };
      }
    } else {
      return {
        mainTitle: "Leaderboards",
        subTitle: fullLabel || "",
      };
    }
  };

  const { mainTitle, subTitle } = getTitleAndDesc();

  return (
    <div className="w-full">
      <LeaderboardHeader mainTitle={mainTitle} subTitle={subTitle} />
      <LeaderboardNav />
      <Switch>
        <Route path={AppRoutes.LEADERBOARD_CHAMPION_RANKING} component={ChampionLeaderboardTab} />
        <Route path={AppRoutes.LEADERBOARD_RANKING} component={LeaderboardRanking} />
        <Redirect to={AppRoutes.LEADERBOARD_RANKING} />
      </Switch>
    </div>
  );
}
